import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import "./PolicyBanner.css";

const PolicyBanner = ({ className = "" }) => {
  const [bannerText, setBannerText] = useState("");
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/controllers/fetch_banner.php?id=1`
        );
        const data = await response.json();
        if (data?.data?.show_banner === 1 && data?.data?.banner_text?.trim()) {
          setBannerText(data.data.banner_text);
          setShowBanner(true);
        }
      } catch (error) {
        console.error("Failed to fetch banner text:", error);
      }
    };

    fetchBanner();
  }, []);

  if (!showBanner || !bannerText) return null;

  return (
    <div className={`policy-banner ${className}`}>
      <div
        className="policy-banner-content"
        dangerouslySetInnerHTML={{ __html: bannerText }}
      />
    </div>
  );
};

PolicyBanner.propTypes = {
  className: PropTypes.string,
};

export default PolicyBanner;
